import { createAction, createStandardAction } from 'typesafe-actions';

import { EventDTO } from '../../types/dto/EventDTO';

export const getEventsRequest = createAction('@@app/GET_EVENTS_REQUEST');
export const getEventsSuccess = createStandardAction('@@app/GET_EVENTS_SUCCESS')<EventDTO[]>();
export const getEventsFailure = createAction('@@app/GET_EVENTS_FAILURE');

export const followSignupRequest = createAction('@@app/FOLLOW_SIGNUP_REQUEST');
export const followSignupSuccess = createAction('@@app/FOLLOW_SIGNUP_SUCCESS');
export const followSignupFailure = createAction('@@app/FOLLOW_SIGNUP_FAILURE');
